import { Container,Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Preloader from '../../components/PreLoader';
import { lang } from '../../config/app.config';
import Branch from '../../models/branch.model';
import { fetchBranch } from '../../services/branchs.service';
import translates from '../../translation.json';
import {Link} from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import {TranslationState} from '../../store/ActionReducers/translation.actionreducer';
interface state{
  branch:{
    branches:Array<Branch>,
    loadingBranch:boolean
  }
}

const BranchPage:React.FC = () =>{


  const dispatch = useDispatch();

  // redux state

  const state = useSelector((state:state)=>{
    const {branch} = state;
    return branch;
  });
  const {branches,loadingBranch} = state;

  useEffect(()=>{
    if(!branches) dispatch(fetchBranch());
  },[dispatch]) //eslint-disable-line

  const stateTr = useSelector((state:{translation:TranslationState})=>state.translation);

  return(
    <>
    <Breadcrumb slug="election-offices" routes={[{title:translates.translation[lang].provice_district_offices}]}/>
    <section className="section-padding-2">
      {loadingBranch?<Preloader/>:
      <Container maxWidth="lg">
        <div className="text-center">
          <h3 className="ecn-title">{stateTr.translation?stateTr.translation.state_election_offices[lang==='np'?"value_np":"value_en"]:""}</h3>
        </div>

        <div className="section-break-1">

          <Grid container spacing={3}>
            {
              branches && branches.length?
              branches.map(b=>{
                if(!b.district){
                  return (
                    <Grid item lg={2} md={4} sm={12}>
                      <Link to={`/${lang}/province/${b.slug}`} key={b.id} className="text-primary" target="_blank">                         
                        <div className="branch-card">
                          <h4 className="text-15-primary text-center">
                          {b.province}
                          </h4>
                        </div>
                      </Link>
                    </Grid>
                  );
                } 
                return "";
              }):""
            }
          </Grid>

        </div>


        <div className="text-center">
          <h3 className="ecn-title">{stateTr?.translation?stateTr?.translation?.district_title[lang==='np'?"value_np":"value_en"]:""}</h3>
        </div>

        <div className="section-break-1">

          <Grid container spacing={3}>
            {
              branches && branches.length?
              branches.map(b=>{
                if(b.district){
                  return (
                    <Grid item lg={2} md={4} sm={12}>
                      <Link to={`/${lang}/district/${b.slug}`} key={b.id} className="text-primary" target="_blank">                         
                        <div className="branch-card">
                          <h4 className="text-15-primary text-center">
                          {b.district}
                          </h4>
                        </div>
                      </Link>
                    </Grid>
                  );
                } 
                return "";
              }):""
            }
          </Grid>

        </div>
      </Container>
    }
    </section>
    </>
  );
}

export default BranchPage;